import { DashboardReportResponse } from 'models/dashboardReports';
import { Response } from 'models/response';
import { RuleForm, RuleRequest, RuleResponse, RulesResponse } from 'models/rule';

import { rules, travel, axiosConfig } from '../api';

export const saveRule = (ruleForm: RuleForm, currentRule?: RuleResponse): Promise<RuleResponse> => {
  const rule: RuleRequest = {
    id: currentRule?.id,
    name: ruleForm.name,
    description: '',
    isActive: true,
    conditions: {
      dateAirDomestic: {
        isActive: ruleForm.nationalFlightAnticipation !== '',
        days: Number(ruleForm.nationalFlightAnticipation),
      },
      dateAirInternational: {
        isActive: ruleForm.internationalFlightAnticipation !== '',
        days: Number(ruleForm.internationalFlightAnticipation),
      },
      valueAirDomestic: {
        isActive: ruleForm.nationalFlightMaxPrice !== '',
        value: Number(ruleForm.nationalFlightMaxPrice),
      },
      valueAirInternational: {
        isActive: ruleForm.internationalFlightMaxPrice !== '',
        value: Number(ruleForm.internationalFlightMaxPrice),
      },
      percentageLlfAirDomestic: {
        isActive: ruleForm.nationalFlightFlexibility !== '',
        value: Number(ruleForm.nationalFlightFlexibility),
      },
      percentageLlfAirInternational: {
        isActive: ruleForm.internationalFlightFlexibility !== '',
        value: Number(ruleForm.internationalFlightFlexibility),
      },
      dateHotelDomestic: {
        isActive: ruleForm.nationalHotelAnticipation !== '',
        days: Number(ruleForm.nationalHotelAnticipation),
      },
      dateHotelInternational: {
        isActive: ruleForm.internationalHotelAnticipation !== '',
        days: Number(ruleForm.internationalHotelAnticipation),
      },
      valueHotelDomestic: {
        isActive: ruleForm.nationalHotelMaxPrice !== '',
        value: Number(ruleForm.nationalHotelMaxPrice),
      },
      valueHotelInternational: {
        isActive: ruleForm.internationalHotelMaxPrice !== '',
        value: Number(ruleForm.internationalHotelMaxPrice),
      },
      dateVehicleDomestic: {
        isActive: ruleForm.nationalVehicleAnticipation !== '',
        days: Number(ruleForm.nationalVehicleAnticipation),
      },
      dateVehicleInternational: {
        isActive: ruleForm.internationalVehicleAnticipation !== '',
        days: Number(ruleForm.internationalVehicleAnticipation),
      },
      valueVehicleDomestic: {
        isActive: ruleForm.nationalVehicleMaxPrice !== '',
        value: Number(ruleForm.nationalVehicleMaxPrice),
      },
      valueVehicleInternational: {
        isActive: ruleForm.internationalVehicleMaxPrice !== '',
        value: Number(ruleForm.internationalVehicleMaxPrice),
      },
      specificAirRoutes: ruleForm.specificRoutes.map((route) => ({
        origin: route.departurePointCode as string,
        originName: route.departurePoint as string,
        destiny: route.arrivalPointCode as string,
        destinyName: route.arrivalPoint as string,
        dateAir: {
          isActive: route.specificFlightAnticipationDays !== '',
          days: route.specificFlightAnticipationDays || 0,
        },
        valueAir: {
          isActive: route.maxPrice !== '',
          value: route.maxPrice || 0,
        },
        percentageLlfAir: {
          isActive: route.specificFlightFlexibility !== '',
          value: route.specificFlightFlexibility || 0,
        },
      })),
      specificHotelLocations: ruleForm.specificDestinations.map((destination) => ({
        location: destination.destinationPoint?.code || '',
        locationName: destination.destinationPoint?.name || '',
        dateHotel: {
          isActive: destination.dateHotel !== '',
          days: destination.dateHotel || 0,
        },
        valueHotel: {
          isActive: destination.maxPrice !== '',
          value: destination.maxPrice || 0,
        },
      })),
      specificVehicleLocations: ruleForm.specificRents.map((location) => ({
        pickup: {
          name: `${location.pickup?.name}`,
          code: `${location.pickup?.code}`,
          latitude: location.pickup && location.pickup.latitude ? location.pickup.latitude : 0,
          longitude: location.pickup && location.pickup.longitude ? location.pickup.longitude : 0,
        },
        dropoff: {
          name: `${location.dropoff?.name}`,
          code: `${location.dropoff?.code}`,
          latitude: location.dropoff && location.dropoff.latitude ? location.dropoff.latitude : 0,
          longitude: location.dropoff && location.dropoff.longitude ? location.dropoff.longitude : 0,
        },
        dateVehicle: {
          isActive: location.dateVehicle !== '',
          days: location.dateVehicle || 0,
        },
        valueVehicle: {
          isActive: location.maxPrice !== '',
          value: location.maxPrice || 0,
        },
      })),
    },
    requireApproval: currentRule?.requireApproval || 'always',
    userGroupIds: ruleForm.groups,
  };

  return !currentRule ? rules.post('/rules', rule) : rules.put(`/rules/${rule.id}`, rule);
};

export const fetchRule = async (ruleId: string) => rules.get<Response<RuleResponse>>(`Rules/${ruleId}`, axiosConfig);

export const fetchRules = async () => rules.get<Response<RulesResponse[]>>('/rules/getall', axiosConfig);

export const deleteRule = async (ruleId: string) => rules.delete(`/rules/${ruleId}`, axiosConfig);

export const getDashboardSummary = async () =>
  travel.get<DashboardReportResponse>('/Travels/GetDashboardSummary', axiosConfig).catch((error) => {
    throw error;
  });
